import { createFileRoute } from "@tanstack/react-router";
import NCPumaDealer from "@/pages/NCPumaDealer";
import { pageHead } from "@/lib/routeHead";

export const Route = createFileRoute("/nc-puma-dealer/")({
  head: () => pageHead({ title: 'NC Puma Dealer', description: 'Rex & Sons RVs is your North Carolina Puma travel trailer dealer.', path: '/nc-puma-dealer' }),
  component: NCPumaDealer,
});